// Slovak

const lang = {
  gateMediaPreviewHeader: 'Môže sa vám tiež páčiť',
  loadmore: 'Zobraziť viac',
  nextMedia: 'Ďalšie médiá',
  previousMedia: 'Predchádzajúce médiá',
  closePost: 'Zatvoriť príspevok',
  nextPost: 'Ďalší príspevok',
  previousPost: 'Predchádzajúci príspevok',
  outOfStock: 'Vypredané',
  numberOfReviews(n) {
    if (n === 1) {
      return 'recenzia'
    }
    return n < 5 ? 'recenzie' : 'recenzií'
  },
  reportFormField: 'Vložte správu, prosím',
  reportPost: 'Nahlásiť príspevok',
  reportFormTitle: 'Chcete nahlásiť tento obrázok?',
  reportFormDetails:
    'Ak sa domnievate, že daný obrázok je nevhodný, nezákonný alebo porušuje práva inej osoby, môžete nahlásiť jeho obsah. Po nahlásení obrázku/textu dostanú moderátori obsahu upozornenie a podniknú príslušné kroky.',
  reportFormMessagePlaceholder: 'Uveďte dôvod nahlásenia',
  reportFormMessageLabel: 'Správa',
  reportFormEmailLabel: 'Váš e-mail',
  reportFormSubmitButtonText: 'Odoslať hlásenie',
  reportFormCancelButtonText: 'Zrušiť',
  reportFormSentTitle: 'Ďakujeme Vám za oznámenie!',
  reportFormSentCloseButtonText: 'Zavrieť',
  cardAndTileAriaLabel: 'Zobrazuje sa zoznam príspevkov z účtov na rôznych sociálnych médiách',
  carouselAriaLabel: 'Zobrazuje sa karusel s príspevkami z účtov na rôznych sociálnych médiách',
  singleAriaLabel: 'Nižšie je uvedený príspevok z účtu na sociálnej sieti',
  poweredBy: 'Vytvorené pomocou Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` zverejnená ${date}` : ''
    const createdByString = userName ? ` od ${userName}` : ''
    return `Fotografia${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Nahrajte svoje médiá',
  openTheGate: 'Otvorte dialógové okno',
}

export default lang
